import { MarketingPackageProjection } from "@urbanx/agx.marketing.client";

export const getMarketingPackageTotal = (
  marketingPackage?: MarketingPackageProjection
) =>
  marketingPackage?.marketingContributions?.vendorUpfrontPayment !== undefined
    ? marketingPackage?.marketingContributions?.vendorUpfrontPayment +
      (marketingPackage?.marketingContributions
        ?.agentContributionNoReimbursement ?? 0) +
      (marketingPackage?.marketingContributions
        ?.agentContributionToBeReimbursed ?? 0)
    : marketingPackage?.confirmedTotal !== undefined
      ? marketingPackage?.confirmedTotal
      : [
          ...(marketingPackage?.inclusions ?? []),
          ...(marketingPackage?.addons ?? []),
        ].reduce((total, item) => {
          return total + (item.pricePerUnit ?? 0);
        }, 0);
